import { chatbotGetChatAction, chatbotPostMessageAction } from "./action";

import { combineReducers } from "redux";
import { createReducer } from "typesafe-actions";
import createLoadingReducer from "../../libraries/packages/redux-utils/src/request/create-loading-reducer";
import createOperationReducer from "../../libraries/packages/redux-utils/src/request/create-operation-reducer";
import createErrorReducer from "../../libraries/packages/redux-utils/src/request/create-error-reducer";
import api from "../storeApi";
import { chatbotListDeleteChatAction } from "../chatbotList/action";

export const chatbotReducer = combineReducers<{
  data: typeof api.chatbot.type;
  lastOpId: string | null;
  isLoading: Set<string>;
  error: Error;
}>({
  data: createReducer(null)
    .handleAction(
      [chatbotGetChatAction.success],
      (state, action) => action.payload
    )
    .handleAction([chatbotPostMessageAction.request], (state, action) =>
      state
        ? {
            ...state,
            messages: [
              ...(state.messages || []),
              {
                createdAt: new Date(),
                author: "user",
                text: action.payload[0].message_text,
                isOptimistic: true,
                id:
                  state.messages.length > 0
                    ? state.messages[state.messages.length - 1].id + 1
                    : 1,
              },
            ],
          }
        : state
    )
    .handleAction([chatbotPostMessageAction.success], (state, action) =>
      state
        ? {
            ...state,
            messages: [
              ...(state.messages || []).filter(
                (_messsage) => !_messsage.isOptimistic
              ),
              action.payload.userMessage,
              action.payload.botMessage,
            ],
          }
        : state
    )
    .handleAction([chatbotListDeleteChatAction.request], (state, action) =>
      !state ? null : state.id === action.payload[0] ? null : state
    ),
  isLoading: createLoadingReducer(
    chatbotPostMessageAction,
    chatbotGetChatAction
  ),
  lastOpId: createOperationReducer(
    chatbotPostMessageAction,
    chatbotGetChatAction
  ),
  error: createErrorReducer(chatbotPostMessageAction, chatbotGetChatAction),
});
